import { apiRequestBase } from "./client";
import { env } from "../config/env";

export const itemApi = {
  searchItems: async (params: {
    searchValue: string;
    warehouseId: number;
    categoryId?: number | null;
  }) => {
    const response = await apiRequestBase<any>(env.itemBaseUrl, "/Item/GetItemsByWarehouseAndCategory", {
      method: "POST",
      body: {
        query: {
          draw: 1,
          start: 0,
          length: 15,
          search: {
            value: params.searchValue,
            regex: false,
          },
        },
        warehouseId: params.warehouseId,
        categoryId: params.categoryId ?? null,
        isAvailableInPOS: true,
      },
    });
    return response?.data?.data ?? [];
  },
};
